import { Component, OnInit } from '@angular/core';
import { BlogPost } from '../Models/BlogPost';
import { AppHttpService } from '../AppServices/app.httpservices';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {
    posts: BlogPost[] = [];
    loading = true;
    error = '';

    constructor(private httpClient: AppHttpService) { }

    ngOnInit() {
        this.httpClient.get<BlogPost[]>('api/Blog/Get', null).subscribe(data => {
            this.posts = data || [];
            this.loading = false;
        }, () => {
            this.loading = false;
            this.error = 'Could not load the blog right now.';
        });
    }

    openPost(slug: string): void {
        window.location.href = '/Blog/' + slug;
    }
}
